import { useEffect, useState } from 'react';
import { OrganizationSettingsApi } from '@/api/clients/organization-settings/organization-settings.api';

const toSet = (arr) => new Set(Array.isArray(arr) ? arr : []);

const normalize = (data) => ({
  email: toSet(data?.emailPaymentMethods),
  letter: toSet(data?.letterPaymentMethods),
  manual: toSet(data?.manualPaymentMethods),
});

export const useGetOrganizationPaymentRailSetting = (organizationId) => {
  const [settings, setSettings] = useState(normalize(null));
  const [loading, setLoading] = useState(!!organizationId);
  const [error, setError] = useState(null);

  useEffect(() => {
    setError(null);
    if (!organizationId) {
      setSettings(normalize(null));
      setLoading(false);
      return;
    }
    let cancelled = false;
    setLoading(true);
    (async () => {
      try {
        const res = await OrganizationSettingsApi.getPaymentRailSetting(
          organizationId,
        );
        if (cancelled) return;
        setSettings(normalize(res.data?.data ?? res.data));
      } catch (err) {
        if (cancelled) return;
        setError(err);
        console.error('Failed to load organization payment rail setting:', err);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [organizationId]);

  return { settings, loading, error };
};
